import {
  makeCreateFiltersAndTermSearchParams,
  makeGetSearchTermFromLocation,
  Filters,
  makeGetFiltersSearchParams
} from "features/course-discovery/utils";

import { textQueryParamInUrl } from "./consts";

export type { Filters };

export const getSearchTermFromLocation =
  makeGetSearchTermFromLocation(textQueryParamInUrl);
export const createFiltersAndTermSearchParams =
  makeCreateFiltersAndTermSearchParams(textQueryParamInUrl);
export const getFiltersSearchParams =
  makeGetFiltersSearchParams(textQueryParamInUrl);
